import { render, staticRenderFns } from "./TinyCard.vue?vue&type=template&id=e81028a0&scoped=true&"
import script from "./TinyCard.vue?vue&type=script&lang=js&"
export * from "./TinyCard.vue?vue&type=script&lang=js&"
import style0 from "./TinyCard.vue?vue&type=style&index=0&id=e81028a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81028a0",
  null
  
)

export default component.exports